<template>
  <div class="content__forms__register">
    <div class="content__options w-full">
      <button
        :disabled="disabledButton.person"
        :class="buttonPerson"
        class="uppercase text-sm py-4 px-2 text-white font-neue option__button"
        @click="changeStateButton()"
      >
        Empresa
      </button>
      <!--
      <button
        :class="buttonCompany"
        :disabled="disabledButton.company"
        class="uppercase text-sm py-4 px-2 text-white font-neue option__button"
        @click="changeStateButton()"
      >
        Persona natural
      </button>
      -->
    </div>
    <div class="register__content">
      <RegisterCompany v-if="buttonState" />
      <!--
      <RegisterPerson v-else />
      -->
    </div>
  </div>
</template>

<script>
import RegisterPerson from "@/components/AuthComponents/RegisterPerson";
import RegisterCompany from "@/components/AuthComponents/RegisterCompany";
export default {
  name: "CustomerRegister",
  components: {
    RegisterPerson,
    RegisterCompany,
  },
  data() {
    return {
      buttonPerson: {
        mainblue: false,
      },
      buttonCompany: {
        mainblue: true,
      },
      buttonState: true,
      disabledButton: {
        person: true,
      },
    };
  },
  methods: {
    changeStateButton() {
      this.buttonState
        ? ((this.buttonState = false),
          (this.buttonPerson.mainblue = false),
          (this.buttonCompany.mainblue = true),
          (this.disabledButton.person = false),
          (this.disabledButton.company = true))
        : ((this.buttonState = true),
          (this.buttonPerson.mainblue = true),
          (this.buttonCompany.mainblue = false),
          (this.disabledButton.person = true),
          (this.disabledButton.company = false));
    },
  },
};
</script>

<style lang="scss" scoped>
.mainblue {
  background: red;
  color: #73c9ff;
}

.mainblue:disabled {
  background: #73c9ff;
  color: white;
  border-radius: 0px;
}

.pin-t-r {
  bottom: 95%;
  left: 95%;
}

.content__forms__register {
  display: flex;
  flex-direction: column;
  background-color: #73c9ff;
  width: 300px;
  max-height: 78vh;
  overflow-y: auto;
  @media (min-width: 992px) {
    width: 470px;
    max-height: 580px;
    overflow-y: auto;
  }
}

.register__content {
  display: flex;
  justify-content: center;
  padding: 1% 0 6% 0;
}

.content__options {
  display: flex;
  width: 100%;
}

.option__button {
  background-color: white;
  color: #73c9ff;
  border-radius: 0px;

  font-size: 0.875rem;

  &:first-child {
    /* width: 44%; */
    width: 100%;
  }
  /*
  &:last-child {
    width: 60%;
  }
  */
}

h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 43px;
  margin-top: -50px;

  @media (min-width: 768px) {
    font-size: 36px;
    margin-top: 0px;
  }
}

button {
  border-radius: 5px;
}
</style>
